<div id="infra">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Activity Room</h4>
                  <div class="card-body">
                    <p class="inner-lead">Welcome to our school's Activity Room! Our activity room is a vibrant space designed to inspire creativity, collaboration, and learning. Our activity room is a place where students can engage in a range of activities and experiences beyond the traditional classroom setting.</p>
                    <p class="inner-lead">At our school, we believe that learning is not limited to the classroom and that students benefit from a range of experiences and activities that foster their creativity and critical thinking skills. Our activity room is a space where students can explore their passions, try new things, and develop their skills and abilities beyond the traditional curriculum.
                    </p>  
                    <p class="inner-lead">Our activity room is not just a place for students to have fun and explore new interests. It is a space that inspires and nurtures young minds, helping them develop their leadership and teamwork skills, and fostering a sense of community and belonging. We are proud of our activity room and the positive impact it has on our students' growth and development.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>